import { c as _c } from "react/compiler-runtime";
import { IcoArray16, IcoBoolean16, IcoDoc16, IcoFileText16, IcoMinusSmall16, IcoNetwork16, IcoObject16, IcoText16 } from '@onefootprint/icons';
import type { DataTokenType } from '@onefootprint/request-types/dashboard';
type TypeIconProps = {
  /** Accepts `DataTokenType`, which covers the schema `SimpleTypes` plus `document` and `unknown`. */
  type: DataTokenType | DataTokenType[];
};
const TypeIcon = t0 => {
  const $ = _c(9);
  const {
    type
  } = t0;
  switch (type) {
    case "string":
      {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <IcoText16 />;
          $[0] = t1;
        } else {
          t1 = $[0];
        }
        return t1;
      }
    case "number":
      {
        let t1;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <IcoNetwork16 />;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        return t1;
      }
    case "integer":
      {
        let t1;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <IcoNetwork16 />;
          $[2] = t1;
        } else {
          t1 = $[2];
        }
        return t1;
      }
    case "boolean":
      {
        let t1;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <IcoBoolean16 />;
          $[3] = t1;
        } else {
          t1 = $[3];
        }
        return t1;
      }
    case "array":
      {
        let t1;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <IcoArray16 />;
          $[4] = t1;
        } else {
          t1 = $[4];
        }
        return t1;
      }
    case "object":
      {
        let t1;
        if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <IcoObject16 />;
          $[5] = t1;
        } else {
          t1 = $[5];
        }
        return t1;
      }
    case "null":
      {
        let t1;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <IcoMinusSmall16 />;
          $[6] = t1;
        } else {
          t1 = $[6];
        }
        return t1;
      }
    case "document":
      {
        let t1;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <IcoDoc16 />;
          $[7] = t1;
        } else {
          t1 = $[7];
        }
        return t1;
      }
    default:
      {
        let t1;
        if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <IcoFileText16 />;
          $[8] = t1;
        } else {
          t1 = $[8];
        }
        return t1;
      }
  }
};
export default TypeIcon;